import type { Store } from 'redux';
import { storeManager } from './storeManager.ts';

/** Gets the store set by {@link setStore} */
export function getStore(): Store {
  if (!storeManager.store) {
    throw new Error('Use setStore() to set the store before accessing it.');
  }

  return storeManager.store;
}